// import { fromJS } from 'immutable';

import {
  LOGIN_SUCCESSFUL,
  // LOGIN_FAILED,
  // LOG_USER_IN,
  USER_LOGOUT,
} from '../actions/actionTypes';

const accessTokenKey = 'accessToken';
const usernameKey = 'username';

const initialState = () => {
  const foundToken = localStorage.getItem(accessTokenKey);
  return {
    auth: {
      loggedIn: !!foundToken,
      token: localStorage.getItem(accessTokenKey),
    },
  };
};

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case LOGIN_SUCCESSFUL: {
      localStorage.setItem(accessTokenKey, action.payload.token);
      localStorage.setItem(usernameKey, action.payload.username);
      return Object.assign(
        {},
        {
          auth: {
            loggedIn: true,
            token: action.payload.token,
          },
        },
      );
    }
    case USER_LOGOUT: {
      localStorage.removeItem(accessTokenKey);
      return Object.assign(
        {},
        {
          auth: {
            loggedIn: false,
            token: null,
          },
        },
      );
    }
    default:
      return state;
  }
};

export default reducer;
